import { Link } from 'react-router-dom';
import { Warehouse, Facebook, Twitter, Instagram, Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-blue-600 p-1.5 rounded-lg">
                <Warehouse className="text-white h-5 w-5" />
              </div>
              <span className="text-lg font-bold text-white">
                EncuentraTrastero
              </span>
            </div>
            <p className="text-sm text-slate-400 mb-4">
              La plataforma líder en España para encontrar el espacio extra que necesitas. Alquiler y venta de trasteros sin comisiones.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><Facebook className="h-5 w-5" /></a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><Twitter className="h-5 w-5" /></a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><Instagram className="h-5 w-5" /></a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Explorar</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/search?type=rent" className="hover:text-blue-400 transition-colors">Alquilar Trastero</Link></li>
              <li><Link to="/search?type=sale" className="hover:text-blue-400 transition-colors">Comprar Trastero</Link></li>
              <li><Link to="/publish" className="hover:text-blue-400 transition-colors">Publicar Anuncio</Link></li>
              {/* Mapa pendiente de implementación futura */}
              {/* <li><Link to="/map" className="hover:text-blue-400 transition-colors">Mapa de Trasteros</Link></li> */}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Ciudades Populares</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/search?city=madrid" className="hover:text-blue-400 transition-colors">Trasteros en Madrid</Link></li>
              <li><Link to="/search?city=barcelona" className="hover:text-blue-400 transition-colors">Trasteros en Barcelona</Link></li>
              <li><Link to="/search?city=valencia" className="hover:text-blue-400 transition-colors">Trasteros en Valencia</Link></li>
              <li><Link to="/search?city=sevilla" className="hover:text-blue-400 transition-colors">Trasteros en Sevilla</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <span>info@encuentratrastero.com</span>
              </li>
              <li><Link to="/help" className="hover:text-blue-400 transition-colors">Centro de Ayuda</Link></li>
              <li><Link to="/terms" className="hover:text-blue-400 transition-colors">Términos y Condiciones</Link></li>
              <li><Link to="/privacy" className="hover:text-blue-400 transition-colors">Política de Privacidad</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 pt-8 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} EncuentraTrastero.com. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
